export enum PhxDataTableScrollMode {
  Infinite = 'infinite',
  Standard = 'standard',
  Virtual = 'virtual'
}
